// extracted by mini-css-extract-plugin
module.exports = {"pageWrap":"Wa-z","heading":"Xa-z","screenReadersOnly":"Ya-z"};